import { Router, RouterProps } from 'react-router-dom';
import { EventProvider, LuxRouter } from '@gemini/fe-utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LuxThemeProvider, LuxLocalizationProvider } from '@gemini/fe-ds-core';
import App from './App';

const queryClient = new QueryClient();

function IntegratorApp({ history }: { history: RouterProps['history'] }) {
  return (
    <QueryClientProvider client={queryClient}>
      <LuxThemeProvider>
        <LuxLocalizationProvider>
          <EventProvider global>
            <LuxRouter history={history} />
            <Router history={history}>
              <App />
            </Router>
          </EventProvider>
        </LuxLocalizationProvider>
      </LuxThemeProvider>
    </QueryClientProvider>
  );
}
export default IntegratorApp;
